import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { CustomerMasterApiService } from '../CommonController/customer-master-service';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-model-page',
  templateUrl: './customer-master-page.component.html',
  styleUrls: ['./customer-master-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DatePipe,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
  ],
})
export class CustomerMasterPageComponent implements OnInit {
  pageNo = 1;
  pageSize = 10;
  totalItems = 0;
  customerList = [];
  searchText = '';

  isAddCustomer = false;
  isCustomerAddForm = true;

  addCustomerForm: FormGroup;
  custId = 0;
  userPermission = [];
  customerPermissionView = false;
  customerPermissionUpdate = false;
  customerPermissionCreate = false;
  customerPermissionDelete = false;

  constructor(
    public customerMasterApiService: CustomerMasterApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.checkPermission();
    this.setCustomerMasterForm();
    this.fetchCustomerList();
  }

  checkPermission() {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Customer Master' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Customer Master' && element.view === true) {
        this.customerPermissionView = true;
      }
      if (element.pageName === 'Customer Master' && element.update === true) {
        this.customerPermissionUpdate = true;
      }
      if (element.pageName === 'Customer Master' && element.create === true) {
        this.customerPermissionCreate = true;
      }
      if (element.pageName === 'Customer Master' && element.delete === true) {
        this.customerPermissionDelete = true;
      }
    });
  }

  setCustomerMasterForm() {
    this.addCustomerForm = this.fb.group({
      id: [0],
      customerName: [
        '',
        [
          SharedValidators.requiredAndNoEmptySpaces,
          SharedValidators.nonNumericNoSpecialChars,
        ],
      ],
    });
  }

  fetchCustomerList() {
    this.spinner.show();
    this.customerMasterApiService
      .getAllCustomer(this.pageNo, this.pageSize, this.searchText)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.customerList = res.data;
          this.totalItems = res.totalItems;
        },
        error: (ERROR: HttpErrorResponse) => {
          this.customerList = [];
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
  }

  saveCustomer() {
    if (this.addCustomerForm.invalid) {
      this.addCustomerForm.get('customerName').markAsTouched();
      return;
    }

    this.spinner.show();
    const payload = this.addCustomerForm.value;
    payload.id = 0;
    this.customerMasterApiService.addCustomer(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.isAddCustomer = false;
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  fetchCustomerById(id) {
    this.customerMasterApiService.getCustomerById(id).subscribe({
      next: (res) => {
        if (res.status) {
          const data = res.data;
          this.isCustomerAddForm = false;
          this.addCustomerForm = this.fb.group({
            customerName: new FormControl(data.customerName, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.nonNumericNoSpecialChars,
            ]),
            updatedAt: new Date(),
          });
          this.custId = data.id;
          this.addCustomer('update');
        } else {
          this.commonApiService.openSnackbar('Operation Failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  addCustomer(operationType) {
    if (operationType === 'add') {
      this.custId = 0;
      this.addCustomerForm.reset();
      this.isCustomerAddForm = true;
    } else {
      this.isCustomerAddForm = false;
    }
    this.isAddCustomer = true;
  }

  updateCustomer() {
    if (this.addCustomerForm.invalid) {
      SharedValidators.markAllAsTouched(this.addCustomerForm);
      return;
    }

    this.spinner.show();
    const payload = this.addCustomerForm.value;
    payload.id = this.custId;
    this.customerMasterApiService.updateCustomer(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.isCustomerAddForm = false;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
          this.isAddCustomer = false;
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar('Operation Failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  deleteCustomer(id) {
    if (confirm('Are you sure? Do you want to delete')) {
      this.spinner.show();
      this.customerMasterApiService.deleteCustomer(id).subscribe({
        next: (res) => {
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
            this.spinner.hide();
            this.ngOnInit();
          } else {
            this.spinner.hide();
            this.commonApiService.openSnackbar('Operation Failed');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
    }
  }

  onPageChange(event) {
    this.pageNo = event;
    this.fetchCustomerList();
  }

  onSizeChange(pageSize): void {
    this.pageSize = pageSize;
    this.pageNo = 1;
    sessionStorage.setItem('pageSize', this.pageSize.toString());
    this.fetchCustomerList();
  }

  onSearchCustomersName(event) {
    this.searchText = event;
    this.pageNo = 1;
    this.fetchCustomerList();
  }

  changePage() {
    this.isAddCustomer = false;
    this.fetchCustomerList();
  }

  onClickAddCustomerRefresh() {
    this.fetchCustomerList();
    if (this.custId === 0) {
      this.addCustomerForm.reset();
    } else {
      this.fetchCustomerById(this.custId);
    }
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
